export default "__VITE_ASSET__CcVeDjyg__"